export const containerStyle = (isDesktop) => ({
  width: "100%",
  height: "calc(100vh - 50px)",
  display: "flex",
  flexDirection: "column",
  gap: isDesktop ? 24 : 16,
  padding: isDesktop ? 0 : "0 16px",
  overflow: "hidden",
});

export const cardStyleList = () => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  gap: 16,
  overflow: "hidden",
});

export const cardStyle = (isDesktop) => ({
  display: "flex",
  flexDirection: "column",
  padding: isDesktop ? 24 : 16,
  boxSizing: "border-box",
  gap: isDesktop ? 24 : 16,
});

export const contentWrapperStyle = (isDesktop) => ({
  display: "flex",
  flexDirection: "column",
  gap: isDesktop ? 16 : 12,
  flex: 1,
});

export const titleStyle = (isDesktop) => ({
  fontSize: isDesktop ? 20 : 18,
  fontWeight: 500,
  color: "var(--color-on-base-content-high)",
});
export const titleDStyle = () => ({
  fontSize: 14,
  fontWeight: 400,
  color: "var(--color-on-base-content-subtle)",
  marginLeft: 10,
});

export const mainContentStyle = (isDesktop) => ({
  display: "flex",
  flexDirection: isDesktop ? "row" : "column",
  gap: 16,
  flex: 1,
});

export const leftSectionStyle = (isDesktop) => ({
  width: isDesktop ? "50%" : "100%",
  display: "flex",
  flexDirection: "column",
  gap: isDesktop ? 16 : 12,
});

export const instructionBoxStyle = (isDesktop) => ({
  display: "flex",
  flexDirection: "column",
  gap: isDesktop ? 24 : 12,
  fontSize: isDesktop ? 12 : 11,
  fontWeight: 400,
  color: "#767A80",
  padding: isDesktop ? 0 : "12px",
  background: isDesktop ? "transparent" : "#F5F8FF",
  borderRadius: isDesktop ? 0 : 8,
});

export const instructionListStyle = {
  paddingLeft: "20px",
  margin: 0,
  lineHeight: 1.6,
};

export const rightSectionStyle = (isDesktop, disabled) => ({
  width: isDesktop ? "50%" : "100%",
  display: "flex",
  flexDirection: "column",
  gap: isDesktop ? 24 : 16,
});

export const formSectionStyle = (isDesktop, disabled) => ({
  display: "flex",
  flexDirection: "column",
  gap: isDesktop ? 16 : 12,
  borderColor: disabled
    ? "var(--color-on-base-border-disable)"
    : "var(--color-on-base-border-default)",
  color: disabled
    ? "var(--color-on-base-content-disable)"
    : "var(--color-on-base-content-high)",
});

export const coordinateWrapperStyle = (isDesktop) => ({
  display: "flex",
  gap: 8,
  flexDirection: isDesktop ? "row" : "column",
});

export const getLocationButtonStyle = (isDesktop, disabled) => ({
  width: isDesktop ? "auto" : "100%",
  maxWidth: isDesktop ? "118px" : "100%",
  minHeight: 32,
  height: isDesktop ? 32 : 40,
  padding: "8px 12px",
  borderRadius: 8,
  border: disabled
    ? "1px solid var(--color-on-base-border-disable)"
    : "1px solid var(--color-primary-border-default)",
  backgroundColor: disabled
    ? "var(--comp-btn-color-background-disable)"
    : "var(--comp-btn-color-background-secondary-normal)",
  color: disabled
    ? "var(--color-on-base-content-disable)"
    : "var(--color-primary-content-default)",
  // background: "#F5F8FF",
  // border: "1px solid #BCD1FF",
  // color: "#2C5DFE",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
  boxSizing: "border-box",
  fontSize: isDesktop ? 12 : 14,
  fontWeight: 500,
});

export const getLocationClearButtonStyle = (isDesktop, disabled) => ({
  width: isDesktop ? "auto" : "100%",
  maxWidth: isDesktop ? "118px" : "100%",
  minHeight: 32,
  height: isDesktop ? 32 : 40,
  padding: "8px 12px",
  borderRadius: 8,
  border: "none",
  backgroundColor: "transparent",
  color: disabled
    ? "var(--color-on-base-content-disable)"
    : "var(--color-primary-content-default)",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
  boxSizing: "border-box",
  fontSize: isDesktop ? 12 : 14,
  fontWeight: 500,
});

export const iconStyle = {
  width: 16,
  height: 16,
  flexShrink: 0,
};

export const buttonTextStyle = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

export const buttonEdit = (isDesktop) => ({
  border: "1px solid var(--color-primary-border-default)",
  backgroundColor: "var(--comp-btn-color-background-secondary-normal)",
  color: "var(--color-primary-content-default)",
  borderRadius: 8,
  height: isDesktop ? 34 : 40,
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
});

export const dividerStyle = {
  border: "none",
  borderTop: "1px solid var(--color-on-base-content-disable)",
  margin: 0,
};

export const settingsSectionStyle = (isDesktop) => ({
  display: "flex",
  flexDirection: isDesktop ? "row" : "column",
  flexWrap: "wrap",
});

export const footerStyle = (isDesktop) => ({
  marginTop: isDesktop ? 0 : 16,
});

export const buttonGroupStyle = (isDesktop) => ({
  display: "flex",
  justifyContent: "flex-end",
  gap: isDesktop ? 16 : 12,
  flexDirection: isDesktop ? "row" : "column-reverse",
});

export const cancelButtonStyle = (isDesktop) => ({
  padding: "0 16px",
  borderRadius: 12,
  border: "1px solid var(--color-on-base-border-default)",
  backgroundColor: "var(--color-base-foreground-elevated-16)",
  color: "var(--color-on-base-content-high)",
  cursor: "pointer",
  maxWidth: isDesktop ? 168 : "100%",
  height: 40,
  width: "100%",
  minHeight: 32,
  boxSizing: "border-box",
  fontSize: 14,
  fontWeight: 500,
});

export const saveButtonStyle = (isDesktop, disabled) => ({
  padding: "0 16px",
  borderRadius: "12px",
  border: disabled ? "1px solid var(--color-on-base-border-disable)" : "none",
  background: disabled
    ? "var(--comp-btn-color-background-disable)"
    : "var(--comp-btn-color-background-primary-normal)",
  color: disabled
    ? "var(--color-on-base-content-disable)"
    : "var(--color-on-primary-content-high)",
  cursor: disabled ? "not-allowed" : "pointer",
  maxWidth: isDesktop ? 168 : "100%",
  height: 40,
  width: "100%",
  minHeight: 32,
  boxSizing: "border-box",
  fontSize: 14,
  fontWeight: 500,
});
export const removeButtonStyle = (isDesktop) => ({
  padding: "0 16px",
  borderRadius: "12px",
  border: "1px solid var(--color-functional-border-error)",
  background: "var(--color-functional-foreground-error-subtle)",
  color: "var(--color-functional-foreground-error)",
  cursor: "pointer",
  maxWidth: isDesktop ? 168 : "100%",
  height: 40,
  width: "100%",
  minHeight: 32,
  boxSizing: "border-box",
  fontSize: 14,
  fontWeight: 500,
});
